import Image from 'next/image';
import React from 'react';
import type { LandingMainMedia } from '@/types';
import styles from './MainMedia.module.scss';

interface Props {
	media: LandingMainMedia;
	alt: string;
	sizes: string;
	priority?: boolean;
	className?: string;
}

const MOBILE_QUERY = '(max-width: 767px)';
const DESKTOP_QUERY = '(min-width: 768px)';

export const MainMedia: React.FC<Props> = ({
	media,
	alt,
	sizes,
	priority,
	className,
}) => (
	<div className={`${styles['media']}${className ? ` ${className}` : ''}`}>
		<picture className={styles['media__picture']}>
			{media.posterMobile && (
				<source
					media={MOBILE_QUERY}
					srcSet={media.posterMobile.src}
					width={media.posterMobile.width}
					height={media.posterMobile.height}
				/>
			)}
			<Image
				src={media.poster}
				alt={alt}
				fill
				sizes={sizes}
				loading={priority ? 'eager' : 'lazy'}
				fetchPriority={priority ? 'high' : undefined}
				className={styles['media__item']}
			/>
		</picture>

		{media.video && (
			<video
				className={styles['media__item']}
				autoPlay
				muted
				loop
				playsInline
				preload={priority ? 'auto' : 'metadata'}
				aria-hidden='true'
			>
				{media.videoMobile ? (
					<>
						<source media={DESKTOP_QUERY} src={media.video} type='video/mp4' />
						<source src={media.videoMobile} type='video/mp4' />
					</>
				) : (
					<source src={media.video} type='video/mp4' />
				)}
			</video>
		)}
	</div>
);
